import { ActionMenu, Button, icons } from '@portal/components'
import React, { useState } from 'react'

import { useDQLEditorContext } from '../dqlEditor/context'
import { DataImportDialog } from './DataImportDialog'
import { ImportMethod } from './types'

const { CloudUpload } = icons

export default function DataImportMenu() {
  const { isLoadingCollections } = useDQLEditorContext()

  const [isOpen, setIsOpen] = useState(false)
  const [importMethod, setImportMethod] = useState<ImportMethod>()

  const handleMethodSelection = (method: ImportMethod) => {
    setImportMethod(method)
    setIsOpen(true)
  }

  const handleDialogClose = () => {
    setIsOpen(false)
  }

  return (
    <>
      <DataImportDialog
        isOpen={isOpen}
        importMethod={importMethod}
        onClose={handleDialogClose}
      />

      <div>
        <ActionMenu
          items={[
            {
              label: 'Import by File',
              onClick: () => handleMethodSelection('file'),
            },
            {
              label: 'Import by JSON',
              onClick: () => handleMethodSelection('json'),
            },
          ]}
          trigger={
            <Button variant="default" disabled={isLoadingCollections}>
              <CloudUpload size={16} className="mr-2" />
              Import
            </Button>
          }
          align="end"
        />
      </div>
    </>
  )
}
